import { useCallback, useState } from 'react';

export interface UsePublishedEditNoticeReturn {
  /**
   * Call after a successful edit to inform the user that the live page is now
   * outdated. No-ops unless the page was published and still in sync.
   */
  notify: () => void;
  /** Props to spread onto the informative dialog. */
  modalProps: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  };
}

/**
 * Surfaces an informative "changes aren't live yet" dialog after a block edit
 * on a published, in-sync page. The edit itself runs immediately — the notice
 * just tells the user the page now needs to be republished.
 */
export function usePublishedEditNotice(
  enabled: boolean
): UsePublishedEditNoticeReturn {
  const [open, setOpen] = useState(false);

  const notify = useCallback(() => {
    if (enabled) setOpen(true);
  }, [enabled]);

  return { notify, modalProps: { open, onOpenChange: setOpen } };
}
